/* Scroll Trigger */
ScrollTrigger.create({
  trigger: "body",
  start: "20",
  toggleClass: {targets: ".navbar", className: "is-scrolled"}
});

/* Search */
document.getElementById("search-trigger").onclick = function() {
    document.getElementById("search").classList.add("open");
};
document.getElementById("search-close").onclick = function() {
    document.getElementById("search").classList.remove("open");
};

/* Swipers */
var swiperHero = new Swiper(".swiper.is-hero", {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 750,
  autoplay: {
    delay: 4000,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});

var swiperTestimonials = new Swiper(".swiper.is-testimonials", {
  slidesPerView: 1,
  spaceBetween: 180,
  speed: 750,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  breakpoints: {
  	991: {
      slidesPerView: 3,
    },
  }
});

var swiperPDP = new Swiper(".swiper.is-pdp", {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 750,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
});

var swiperReco = new Swiper(".swiper.is-reco", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  breakpoints: {
  	767: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 4,
    },
  }
});

/* Lottie */
document.addEventListener('DOMContentLoaded', function () {

    lottie.loadAnimation({
        container: document.getElementById('logo-lottie'),

        renderer: 'svg',

        loop: true,

        autoplay: true,

        path: 'https://cdn.shopify.com/s/files/1/0830/5039/7955/files/Clara-signature.json?v=1785866435'

    });

});

/* Fancybox */
$.fancybox.defaults.animationEffect = "fade";

/* Tabs */
document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.querySelectorAll('.w-tab-link');

  tabs.forEach(function (tab) {

    tab.addEventListener('mouseenter', function () {
      tab.click();
    });

  });

});

/* Popup */
document.addEventListener('DOMContentLoaded', function() {
    const popup = document.querySelector('.popup-wrapper');
    const closeButton = document.querySelector('.popup-close');

    // Unique localStorage key for this popup
    const storageKey = 'newsletterPopupLastShown';

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    // Check when the popup was last shown
    const lastShown = localStorage.getItem(storageKey);

    // Only show if it has not already been shown today
    if (lastShown !== today) {

        setTimeout(function() {
            popup.classList.add('is-visible');

            // Record that the popup was shown today
            localStorage.setItem(storageKey, today);
        }, 5000);

    }

    // Close popup
    closeButton.addEventListener('click', function() {
        popup.classList.remove('is-visible');
    });

});

/* Wholesale Popup */
function openPopup() {
  $(".packlist-popup").addClass("is-visible");
}
function closePopup() {
  $(".packlist-popup").removeClass("is-visible");
}